export { forBusiness_apparel_eCommerce } from './eCommerceData';
export { forBusiness_apparel_quality } from './qualityData';
export { forBusiness_apparel_benefits } from './benefitsData';
export { forBusiness_apparel_getStarted } from './getStartedData';
export { forBusiness_apparel_tips } from './tipsData';
export { forBusiness_apparel_perfect } from './perfectData';
